export class ServiceInfo {
    address: string;
    idaResource: string;
    envType: string;
}
